<template>
  <div>
    <header class="position-fixed top-0 w-100 z-index-1040 py-0">
      <div class="w-100 py-2" :class="$is_mobile_view ? 'bg-green' : 'bg-white'">
        <div class="ga-container" :class="{'fluid' : containerFluid}">
          
          <!-- DESKTOP VIEW -->
          <div class="row align-items-center" v-if="!$is_mobile_view">
            <div class="col-2 py-2">
              <img class="cursor-pointer" @click="goToPage('MerchantHome')" :src="getMerchant.image_url" width="50"
                :alt="getMerchant.name">
            </div>
            <div class="col-8">
              <div v-if="showStepSection" class="d-flex align-items-center justify-content-center">
                <div 
                  class="d-flex align-items-center" 
                  :class="{ 'mr-4': stepIndex+1 < steps.length }"
                  v-for="(step, stepIndex) in steps" >
                  
                  <span v-if="step.order >= currentStep" class="step-number body-3-3-2 font-lato mr-2" :class="{'active' : step.order === currentStep }">{{ step.order }}</span>
                  <svg class="mr-2" v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 23.9882C18.5648 23.9882 24 18.5439 24 11.9941C24 5.43262 18.553 0 11.9883 0C5.4353 0 0 5.43262 0 11.9941C0 18.5439 5.44707 23.9882 12 23.9882Z" class="fill-primary"/>
                    <path d="M10.6824 17.7442C10.2824 17.7442 9.95296 17.5796 9.64709 17.1681L6.69413 13.5463C6.51767 13.3111 6.41178 13.0524 6.41178 12.782C6.41178 12.2528 6.82355 11.8177 7.35296 11.8177C7.69413 11.8177 7.95296 11.9235 8.24707 12.3116L10.6354 15.3924L15.6589 7.32581C15.8824 6.97304 16.1883 6.7849 16.4942 6.7849C17.0118 6.7849 17.4942 7.13767 17.4942 7.69033C17.4942 7.94904 17.3412 8.21949 17.2 8.46643L11.6706 17.1681C11.4235 17.5561 11.0824 17.7442 10.6824 17.7442Z" fill="white"/>
                  </svg>
  
                  <p class="mb-0 body-2-4" :class="{'text-subcolor' : step.order > currentStep}">{{ step.title }}</p>
  
                  <template v-if="stepIndex+1 < steps.length">
                    <svg class="ml-4" width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.08521 7.17587C8.08521 6.96918 8.0026 6.77904 7.8455 6.63023L1.29793 0.214945C1.14913 0.0744042 0.96725 0 0.75231 0C0.330685 0 0 0.322417 0 0.75231C0 0.958989 0.0826715 1.14913 0.214945 1.28967L6.23341 7.17587L0.214945 13.062C0.0826715 13.2025 0 13.3845 0 13.5994C0 14.0293 0.330685 14.3517 0.75231 14.3517C0.96725 14.3517 1.14913 14.2773 1.29793 14.1285L7.8455 7.72148C8.0026 7.56444 8.08521 7.3825 8.08521 7.17587Z" fill="#222222"/>
                    </svg>
                  </template>
                  
                  <!-- <svg v-if="stepIndex+1 < steps.length" class="ml-4" width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.0926 7.38514C18.0926 7.14157 17.9952 6.91748 17.8004 6.73237L11.3408 0.292288C11.1264 0.0779435 10.9218 0 10.688 0C10.2106 0 9.84034 0.350746 9.84034 0.837891C9.84034 1.07172 9.91832 1.29581 10.0742 1.45169L12.2566 3.67309L16.1245 7.20003L16.3194 6.71288L13.1822 6.51802H0.857379C0.350746 6.51802 0 6.87852 0 7.38514C0 7.89178 0.350746 8.25227 0.857379 8.25227H13.1822L16.3194 8.05741L16.1245 7.58001L12.2566 11.0972L10.0742 13.3186C9.91832 13.4647 9.84034 13.6986 9.84034 13.9324C9.84034 14.4196 10.2106 14.7703 10.688 14.7703C10.9218 14.7703 11.1264 14.6826 11.3213 14.4975L17.8004 8.03792C17.9952 7.8528 18.0926 7.62872 18.0926 7.38514Z" fill="black" fill-opacity="0.85"/>
                  </svg> -->
                </div>
              </div>
            </div>
            <div class="col-2 text-right">
              <div class="d-flex align-items-center justify-content-end">
                <!-- CURRENCY AND LANGUAGE -->
                <div 
                  class="menu-hover-bottom my-auto text-center h-fit-content cursor-pointer"
                  @click="toggleShowLanguagePopup(true)">
                  <p class="mb-0 body-2-4 d-inline-block align-middle ml-6px">
                    {{ getCurrency.code }}</p>
                </div>
  
                <!-- AUTH -->
                <div class="ml-4 pl-4 border-l-semi-grey-2">
                  <button v-if="!isLoggedIn" class="g-btn g-btn-md g-btn-primary-outline"
                    @click="$openAuthModal({ view: 'login' })">SIGN IN</button>
                  <div class="no-ws menu-hover-bottom cursor-pointer" v-else @click="goToPage('Account')">
                    <div class="d-inline-block align-middle rounded-100 border-semi-grey overflow-hidden"
                      style="height: 22px;width: 22px;">
                      <img class="img-fit" :src="getCurrentUser.avatar" alt="User Avatar">
                    </div>
                    <p class="mb-0 body-2-4 d-inline-block align-middle ml-2">{{getCurrentUser.first_name}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- MOBILE VIEW -->
          <div class="w-100 d-flex align-items-center justify-content-between" v-else>
            <div class="d-flex align-items-center">
              <router-link :to="`/${getMerchant.code}/booking`">
                <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.0294189 8.00744C0.0294189 8.27112 0.145437 8.5137 0.356381 8.7141L7.35969 15.7069C7.57064 15.9073 7.79213 16.0022 8.04526 16.0022C8.56207 16.0022 8.97341 15.6225 8.97341 15.0951C8.97341 14.842 8.87848 14.5889 8.70973 14.4306L6.34717 12.0259L2.1705 8.21839L1.949 8.7352L5.34519 8.94614H18.6874C19.2358 8.94614 19.6155 8.5559 19.6155 8.00744C19.6155 7.45899 19.2358 7.06874 18.6874 7.06874H5.34519L1.949 7.27969L2.1705 7.80705L6.34717 3.98898L8.70973 1.58422C8.87848 1.41546 8.97341 1.17288 8.97341 0.919749C8.97341 0.392393 8.56207 0.0126953 8.04526 0.0126953C7.79213 0.0126953 7.57064 0.0970726 7.3386 0.32911L0.356381 7.30079C0.145437 7.50118 0.0294189 7.74376 0.0294189 8.00744Z" class="fill-white"/>
                </svg>
              </router-link>
              <p class="mb-0 body-1-4 ml-3 text-white">Form Order</p>
            </div>
  
            <router-link :to="`/${getMerchant.code}/account`">
              <div @click="setActiveRoute('cart')">
                <img 
                  v-if="isLoggedIn" style="padding: 2px"
                  :src="getCurrentUser.avatar" 
                  width="40" 
                  height="40" 
                  class="rounded-100 border-2-green object-fit"> 
                <img 
                  v-else
                  src="../../assets/img/icon/user.png" 
                  width="40" 
                  height="40" 
                  class="rounded-100 p-1 object-fit" 
                  style="background-color: #cfcfcf">
              </div>
            </router-link>
          </div>
           
        </div>
      </div>
      
      <!-- STEPPER FOR MOBILE -->
      <div class="w-100 py-2 bg-white box-shadow-light-aff" v-if="$is_mobile_view">
        <div class="ga-container" :class="{'fluid' : containerFluid}">
          <div class="d-flex align-items-start justify-content-center py-1">
          <template v-for="(step, stepIndex) in steps">
            <div 
              class="d-flex align-items-center" >
              
              <div class="flex-shrink-0 text-center">
                <div class="w-100 mb-1 lh-1">
                  <span v-if="step.order >= currentStep" class="step-number body-3-3-2 font-lato mx-auto" :class="{'active' : step.order === currentStep }">{{ step.order }}</span>
                  <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 23.9882C18.5648 23.9882 24 18.5439 24 11.9941C24 5.43262 18.553 0 11.9883 0C5.4353 0 0 5.43262 0 11.9941C0 18.5439 5.44707 23.9882 12 23.9882Z" class="fill-primary"/>
                    <path d="M10.6824 17.7442C10.2824 17.7442 9.95296 17.5796 9.64709 17.1681L6.69413 13.5463C6.51767 13.3111 6.41178 13.0524 6.41178 12.782C6.41178 12.2528 6.82355 11.8177 7.35296 11.8177C7.69413 11.8177 7.95296 11.9235 8.24707 12.3116L10.6354 15.3924L15.6589 7.32581C15.8824 6.97304 16.1883 6.7849 16.4942 6.7849C17.0118 6.7849 17.4942 7.13767 17.4942 7.69033C17.4942 7.94904 17.3412 8.21949 17.2 8.46643L11.6706 17.1681C11.4235 17.5561 11.0824 17.7442 10.6824 17.7442Z" fill="white"/>
                  </svg>
                </div>
                <p class="mb-0 body-3-1 w-100" :class="{'text-subcolor' : step.order > currentStep}">{{ step.title }}</p>
              </div>
  
            </div>
            <template v-if="stepIndex+1 < steps.length">
              <svg class="mx-4 flex-shrink-0 mt-2" height="12" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.08521 7.17587C8.08521 6.96918 8.0026 6.77904 7.8455 6.63023L1.29793 0.214945C1.14913 0.0744042 0.96725 0 0.75231 0C0.330685 0 0 0.322417 0 0.75231C0 0.958989 0.0826715 1.14913 0.214945 1.28967L6.23341 7.17587L0.214945 13.062C0.0826715 13.2025 0 13.3845 0 13.5994C0 14.0293 0.330685 14.3517 0.75231 14.3517C0.96725 14.3517 1.14913 14.2773 1.29793 14.1285L7.8455 7.72148C8.0026 7.56444 8.08521 7.3825 8.08521 7.17587Z" fill="#222222"/>
              </svg>
            </template>
          </template>
        </div>
        </div>
      </div>
    </header>

    <GeneralLanguageCurrency :showPopup="showLanguagePopup" @togglePopup="toggleShowLanguagePopup" />
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import GeneralLanguageCurrency from './GeneralLanguageCurrency.vue';

  export default {
    props:{
      steps:{
        type: Array,
        default: () => []
      },
      currentStep:{
        type: Number,
        default: 1
      },
      containerFluid: {
        type: Boolean,
        default: false
      }
    },  
    components:{
      GeneralLanguageCurrency
    },
    data(){
      return{
        showLanguagePopup: false
      }
    },
    computed:{
      ...mapGetters(['getMerchant','isLoggedIn', 'getCurrentUser', 'getCurrency']),
      showStepSection(){
        return this.$isNotEmptyV2(this.steps);
      }
    },
    methods:{
      ...mapMutations(['setActiveRoute']),
      toggleShowLanguagePopup(show=false){
        this.showLanguagePopup = show
      },
      goToPage(page) {
        this.$router.push({
          name: page,
          params: {
            merchant_code: this.getMerchant.code
          }
        })
      },
    }
  }
</script>
<style scoped>
  .step-number{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid #CCC;
    background-color: #FFF;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #777 !important;
  }
  .step-number.active{
    border: 2px solid var(--merchant-primary-color);
    background-color: var(--merchant-primary-color);
    color: #fff !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/general/GeneralTopNavbar.vue